export default __webpack_public_path__ + "static/marinade-bcb0db43d541ff17d231492c793af075.png";